export default "__VITE_ASSET__CHe2_zN0__"